export const fightersPageTranslations = {
    en: {
        profile_list_title: "Profile list",
        athlete: "Athlete",
        organisations: "Organisations",
        search_name_placeholder: "Search by nickname, team, gym...",
        location_placeholder: "Location",
        combat_sport_placeholder: "Fighting discipline",
        weight_class_placeholder: "Weight Class",
        fights_count_placeholder: "Fights count",
        country_placeholder: "Country",
        rating_placeholder: "Rating",
        title_holder_placeholder: "Title Holder",
        title_holder: "Title holder",
        verified: "Verified",
        reset_filters_tooltip: "Reset all filters",
        gender_placeholder: "Gender",
        male: "Male",
        female: "Female",
        others: "Others",
        loading_text: "Loading...",
        error_countries: "Failed to load countries",
        error_fighters: "Failed to load fighters",
        error_sports: "Failed to load training disciplines",
        error_weight_classes: "Failed to load weight classes",
        table_column_fighter: "Fighter",
        table_column_phone: "Phone",
        table_column_location: "Location",
        table_column_disciplines: "Disciplines",
        table_column_weight_class: "Weight Class",
        table_column_gender: "Gender",
        table_column_title: "Title",
        table_column_status: "Status",
        table_column_actions: "Actions",
        table_empty_content: "No fighters found",
        edit_fighter_tooltip: "Edit fighter",
        pagination_showing: "Showing {start} to {end} of {total} fighters",
        all_locations: "All Locations",
        all_sports: "All Sports",
        all_weight_classes: "All Weight Classes",
        all_titles: "All Titles",
        yes: "Yes",
        no: "No",
        na: "N/A",
    },

    de: {
        profile_list_title: "Profilliste",
        athlete: "Athlet",
        organisations: "Organisationen",
        search_name_placeholder: "Nach Spitzname, Team, Gym suchen...",
        location_placeholder: "Standort",
        combat_sport_placeholder: "Kampfsportdisziplin",
        weight_class_placeholder: "Gewichtsklasse",
        fights_count_placeholder: "Anzahl der Kämpfe",
        country_placeholder: "Land",
        rating_placeholder: "Bewertung",
        title_holder_placeholder: "Titelträger",
        title_holder: "Titelträger",
        verified: "Verifiziert",
        reset_filters_tooltip: "Alle Filter zurücksetzen",
        gender_placeholder: "Geschlecht auswählen",
        male: "Männlich",
        female: "Weiblich",
        others: "Andere",
        loading_text: "Laden...",
        error_countries: "Länder konnten nicht geladen werden",
        error_fighters: "Kämpfer konnten nicht geladen werden",
        error_sports: "Trainingsdisziplinen konnten nicht geladen werden",
        error_weight_classes: "Gewichtsklassen konnten nicht geladen werden",
        table_column_fighter: "Kämpfer",
        table_column_phone: "Telefon",
        table_column_location: "Standort",
        table_column_disciplines: "Disziplinen",
        table_column_weight_class: "Gewichtsklasse",
        table_column_gender: "Geschlecht",
        table_column_title: "Titel",
        table_column_status: "Status",
        table_column_actions: "Aktionen",
        table_empty_content: "Keine Kämpfer gefunden",
        edit_fighter_tooltip: "Kämpfer bearbeiten",
        pagination_showing: "Zeigt {start} bis {end} von {total} Kämpfern",
        all_locations: "Alle Standorte",
        all_sports: "Alle Sportarten",
        all_weight_classes: "Alle Gewichtsklassen",
        all_titles: "Alle Titel",
        yes: "Ja",
        no: "Nein",
        na: "N/V",
    },

    hr: {
        profile_list_title: "Popis profila",
        athlete: "Sportaš",
        organisations: "Organizacije",
        search_name_placeholder: "Pretraži po nadimku, timu, dvorani...",
        location_placeholder: "Lokacija",
        combat_sport_placeholder: "Borilačka disciplina",
        weight_class_placeholder: "Kategorija težine",
        fights_count_placeholder: "Broj borbi",
        country_placeholder: "Država",
        rating_placeholder: "Ocjena",
        title_holder_placeholder: "Nositelj titule",
        title_holder: "Nositelj titule",
        verified: "Verificiran",
        reset_filters_tooltip: "Resetiraj sve filtre",
        gender_placeholder: "Odaberite spol",
        male: "Muško",
        female: "Žensko",
        others: "Ostalo",
        loading_text: "Učitavanje...",
        error_countries: "Neuspjelo učitavanje zemalja",
        error_fighters: "Neuspjelo učitavanje boraca",
        error_sports: "Neuspjelo učitavanje sportova",
        error_weight_classes: "Neuspjelo učitavanje kategorija težine",
        table_column_fighter: "Borac",
        table_column_phone: "Telefon",
        table_column_location: "Lokacija",
        table_column_disciplines: "Discipline",
        table_column_weight_class: "Kategorija težine",
        table_column_gender: "Spol",
        table_column_title: "Titula",
        table_column_status: "Status",
        table_column_actions: "Akcije",
        table_empty_content: "Nema pronađenih boraca",
        edit_fighter_tooltip: "Uredi borca",
        pagination_showing: "Prikazujem {start} do {end} od {total} boraca",
        all_locations: "Sve lokacije",
        all_sports: "Svi sportovi",
        all_weight_classes: "Sve kategorije težine",
        all_titles: "Sve titule",
        yes: "Da",
        no: "Ne",
        na: "N/A",
    },
};